import React, { Component } from "react";
import styles from "./MultipleDistributorUpload.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import _, { get } from "lodash";
import request from "../../../utils/request";
import { ReactComponent as TrashIcon } from "../../../assets/SVGs/delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/SVGs/edit-icon.svg";
import { ReactComponent as BoxClosed } from "../../../assets/SVGs/plus.svg";

import { toast } from "react-toastify";
import {
  ACTIVE_DISTRIBUTORS,
  ACTIVE_PUBLISHERS,
  API_URL,
  ARTIST_API,
  AUTH,
  DISTRIBUTOR_API,
  PUBLISHER_API,
  USER_API,
} from "../../../routes/constants";
import { getInstance } from "./helper";
import SingleFileUploadFiles from "../../../components/UploadFiles/SingleFileUploadFiles";
import { Button2 } from "../../../components";

class MultipleUploads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      apiLoading: false,
      files: [],
      selectOptions: [],
      isOpen: false,
      distributorInfo: {
        id: "",
        name: "",
        instructionsUrl: "",
        instructionsHTML: "",
        logoUrl: "",
      },
      submitloading: false,
      uploadConfirmation: false,
      showUploadFile: true,
      distributorsUploaded: {},
      isEdit: false,
    };
  }

  resetState = (additionalStates = {}) => {
      this.setState({
        loading: false,
        apiLoading: false,
        files: [],
        selectOptions: [],
        isOpen: false,
        distributorInfo: {
          id: "",
          name: "",
          instructionsUrl: "",
          instructionsHTML: "",
          logoUrl: "",
        },
        submitloading: false,
        uploadConfirmation: false,
        showUploadFile: true,
        distributorsUploaded: {},
        isEdit: false,
        ...additionalStates,
      });
    };

  componentDidMount() {
    if (this.props.type === "Distributor")  {
      this.getActive(ACTIVE_DISTRIBUTORS);
    } else {
      this.getActive(ACTIVE_PUBLISHERS)
    }
    
    getInstance.call(this);
  }

  getActive = (path) => {
    this.setState({ apiLoading: true });
    const data = {
      method: "GET",
    };

    const requestUrl = `${API_URL}${USER_API}${ARTIST_API}${path}`
    request(requestUrl, data)
      .then((res) => {
        if (res.status) {
          const options = res.data.map((option) => {
            return {
              label: get(option, "name", ""),
              value: get(option, "_id"),
              logoUrl: get(option, "logoUrl"),
            };
          });
          options.push({ label: "Other", value: "other", name: "" });
          this.setState({ selectOptions: options, apiLoading: false });
          return true;
        }
        this.setState({ apiLoading: false });
        toast.error(get(res, "message"));
        return false;
      })
      .catch((err) => {
        this.setState({ apiLoading: false });
        toast.error(get(err, "message"));
      });
  };

  onChange = ( option, isOther) => {
    if (option.value === "other" || isOther === true) {
      const distributorInfo = {
        _id: option.value,
        name: option.value,
        otherName: `other`,
        isOther: true,
      };
      distributorInfo.isEditMode = isOther === true;
      this.setState({
        distributorInfo,
        isOpen: true,
        loading: false,
      });
      return true;
    }
    const data = {
      method: "GET",
    };
    var path = `${API_URL}${USER_API}${ARTIST_API}${PUBLISHER_API}?id=${option.value}`;
    if (this.props.type === "Distributor")  {
      path = `${API_URL}${AUTH}${ARTIST_API}${DISTRIBUTOR_API}?id=${option.value}`;
    };
    const requestUrl = path;
    request(requestUrl, data)
      .then((res) => {
        this.setState({ loading: false });
        if (res.status) {
          const { instructionsHTML, name } = res.data;
          var distributorInfo = {
            _id: res.data._id,
            name,
            instructionsUrl: res.data.instructionsPdf,
            instructionsHTML,
            logoUrl: res.data.publisherLogo,
          };
          if (this.props.type === "Distributor")  {
            distributorInfo = {
              _id: res.data._id,
              name,
              instructionsUrl: res.data.instructionsUrl,
              instructionsHTML,
              logoUrl: res.data.logoUrl,
            };
          };
          this.setState({ isOpen: true, distributorInfo });
          return true;
        }
        toast.error(get(res, "message"));
        return false;
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(get(err, "message"));
      });
  };

  closeModal = () => this.setState({ isOpen: false });

  updateFileList = (file, isDelete) => {
    const { files } = this.state;
    if (isDelete) {
      _.remove(files, (f) => f.name === file.name);
    } else {
      files.push(file);
    }
    this.setState({ files });
  };

  updateDistributorFiles = () => {
    const { distributorInfo, files, distributorsUploaded, isEdit } = this.state;
    if (!distributorInfo?._id) return;
    const id = distributorInfo._id;
    const updatedDistributors = { ...distributorsUploaded };

    const combinedFiles = isEdit
      ? [...(files || [])]
      : [...(distributorsUploaded[id]?.files || []), ...(files || [])];
    if (combinedFiles.length === 0) {
      delete updatedDistributors[id];
    } else {
      updatedDistributors[id] = {
        id,
        name: distributorInfo.name,
        logoUrl: distributorInfo.logoUrl,
        files: combinedFiles,
      };
    }
    this.props.updateFiles(updatedDistributors);
    this.setState({
      distributorsUploaded: updatedDistributors,
      showUploadFile: false,
      files: [],
      isEdit: false,
      distributorInfo: {
        id: "",
        name: "",
        instructionsUrl: "",
        instructionsHTML: "",
        logoUrl: "",
      },
    });
  };

  openUploadReport = (id) => {
    const { distributorsUploaded } = this.state;
    if (id) {
      const distributorInfo = {
        _id: id,
        name: distributorsUploaded[id].name,
        logoUrl: distributorsUploaded[id].logoUrl,
      };
      this.setState({
        showUploadFile: true,
        distributorInfo,
        files: distributorsUploaded[id].files,
        isEdit: true,
      });
    } else {
      this.setState({ showUploadFile: true, isEdit: false });
    }
  };

  closeUploadReport = () => {
    this.setState({ showUploadFile: false, isEdit: false });
  };

  handleDelete = (id) => {
    const updatedDistributors = { ...this.state.distributorsUploaded };
    delete updatedDistributors[id];
    this.props.updateFiles(updatedDistributors);
    this.setState({
      distributorsUploaded: updatedDistributors,
    });
  };

  renderSelectedDistributorsReport = () => {
    return (
      <>
        <div className={styles.uploadedDistributorList}>
          {Object.values(this.state.distributorsUploaded).map(
            ({ id, name, logoUrl, files }) => (
              <div className={styles.uploadedDistributorCard} key={id}>
                <div className={styles.uploadedDistributorInfo}>
                  <img src={logoUrl} alt={name} className={styles.logo} />
                  <div>
                    <div className={styles.name}>{name}</div>
                    <div className={styles.subtext}>
                      {files.length} File(s) Uploaded
                    </div>
                  </div>
                </div>
                <div className={styles.uploadedActions}>
                  <span
                    className={styles.iconButton}
                    onClick={() => this.openUploadReport(id)}
                  >
                    <EditIcon />
                  </span>
                  <span
                    className={styles.iconButton}
                    onClick={() => this.handleDelete(id)}
                  >
                    <TrashIcon />
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </>
    );
  };

  uploadReportModal = () => {
    const { distributorInfo } = this.state;
    return (
      <div className={styles.reportModal}>
        <div className={styles.headerCtn}>
          <h6 className={styles.heading}>{this.props.type === "Distributor" ? "Distribution Reports:" : "Publishing Reports:"}</h6>
          {!this.state.showUploadFile ? (
            <Button2
            type="button"
            sm
            className={styles.addButton}
            tertiary
            onClick={() => this.openUploadReport()}
          >
          <p>Add Reports</p> <BoxClosed /> 
          </Button2>
          ) : !this.state.isEdit && Object.values(this.state.distributorsUploaded).length ? (
            <Button2
              type="button"
              sm
              className={styles.addButton}
              tertiary
              onClick={() => this.closeUploadReport()}
            >
            <p>Cancel</p>
            </Button2>
          ) : (null)}
        </div>
        {!this.state.showUploadFile && !this.state.isEdit && (
          <div className={styles.overlayClass}>
            {this.renderSelectedDistributorsReport()}
          </div>
        )}
        {this.state.showUploadFile && (
          <div className={styles.overlayClass}>
            {this.props.type === "Distributor" ? (
              <SingleFileUploadFiles
                handleClose={this.closeModal}
                label="Select a Distributor"
                placeholder="Select your Main Distributor"
                distributorInfo={distributorInfo}
                updateFileList={this.updateFileList}
                isUploadReports={true}
                selectOptions={this.state.selectOptions}
                onChange={this.onChange}
                totalFiles={this.state.files.length}
                loading={this.state.loading}
                initialFiles={
                  this.state.distributorsUploaded[distributorInfo?._id]?.files ||
                  []
                }
                isEdit={this.state.isEdit}
                {...this.props}
              />
            ) :(
              <SingleFileUploadFiles
                handleClose={this.closeModal}
                label="Select a Publisher"
                placeholder="Select your Main Publisher"
                distributorInfo={distributorInfo}
                updateFileList={this.updateFileList}
                isUploadReports={true}
                selectOptions={this.state.selectOptions}
                onChange={this.onChange}
                totalFiles={this.state.files.length}
                loading={this.state.loading}
                initialFiles={
                  this.state.distributorsUploaded[distributorInfo?._id]?.files ||
                  []
                }
                isEdit={this.state.isEdit}
                {...this.props}
              />    
            )}
            { !!this.state.files.length && (
              <Button2
                type="button"
                full
                md
                outline
                onClick={this.updateDistributorFiles}
              >
                <p>Mark {this.props.type ? this.props.type : ""} Complete</p>
              </Button2>
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    return (
      <>
        <div className={styles.mainEstimatesDiv}>
          {!this.state.apiLoading ? (
            this.uploadReportModal()
          ) : (
            <div className={styles.spinDiv}>
              <FontAwesomeIcon icon={faCircleNotch} className="spin" />
            </div>
          )}
        </div>
      </>
    );
  }
}

export default MultipleUploads;
